import React, { useContext, useState } from 'react';
import { useApi } from '../useAPI';
import { UserContext } from '../UserContext';
import LoadingSpinner from '../loadingspinner';

const GameOnline = () => {
  const { userData } = useContext(UserContext);
  const { roomsLatest } = useApi();
  const [loading] = useState(false);
  const roomLatest = userData?.roomLatest || []

  const handleSubmit = async (e) => {
    if (e != null) {
      e.preventDefault();
    }
    const result1 = await roomsLatest();
    if (!result1.success) {
      console.error('roomsLatest failed:', result1.error || result1.status);
    }
  };

  return (
    <div>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <button
            type="submit"
            className="refresh-button"
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 1)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 0.7)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Refresh
          </button>
        </form>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : roomLatest.length === 0 ? (
        <div>No online activity</div>
      ) : (
        <div>
          <h2>Online Players</h2>
          <table>
            <tr>
              <th>When</th>
              <td>
                {roomLatest[0]?.observed_at
                  ? new Date(roomLatest[0].observed_at.replace(' ', 'T') + 'Z').toLocaleString()
                  : 'N/A'}
              </td>
            </tr>
            <tr><th>Room</th><td>{roomLatest[0]?.room_name || 'N/A'}</td></tr>
            <tr><th>Players</th><td>{roomLatest[0]?.metadata?.roomNicknames || 'N/A'}</td></tr>
            <tr><th>Level</th><td>{roomLatest[0]?.metadata?.levelName || 'N/A'}</td></tr>
          </table>
        </div>
      )}
    </div>
  );
};

export default GameOnline;
